import Providers from '@/components/page-components/providers';
import useStore from '@/hooks/useStore';
import MainLayout from '@layouts/MainLayout';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProvidersPage: FC = () => {
  const { authStore } = useStore();
  const { user } = authStore;
  const isSEG = user?.company?.tenant_is_seg_parent || false;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSEG) {
      navigate('/dashboard');
    }
  }, [isSEG]);

  return (
    <MainLayout title="Providers" background="white">
      <Providers />
    </MainLayout>
  );
};

export default ProvidersPage;
